import { render } from "./CustomerText.vue?vue&type=template&id=70817acd"
import script from "./CustomerText.vue?vue&type=script&lang=js"
export * from "./CustomerText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__